import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { FallbackComponent } from "../../../../shared/components/FallbackComponent";
import Grid from "../../../../components/components/Grid/Grid";
import { Cell, Column } from "react-table";
import './CustomerPolicyGrid.scss';

export interface PolicyGridProps {
  data: object[]; 
  columns: Column<object>[];
  gridId: string; 
  noRecordsMessage?: string;
  sortDefault?:any;
  disableSorting?:boolean
  selectedColumn?:any;
  hiddenColumns?: string[];
  highlightColumn?: string;
  enableDefaultSelection? : boolean
  enableMandatorySelection?: boolean
  
  
}

const PolicyGrid: React.FunctionComponent<PolicyGridProps> = ({
  data,
  columns,
  gridId,
  noRecordsMessage = "No record found",
  sortDefault,
  selectedColumn,
  highlightColumn,
  hiddenColumns,
  disableSorting,
  enableDefaultSelection,
  enableMandatorySelection

}) => {
  return (
    <>
      <br />
      <ErrorBoundary FallbackComponent={FallbackComponent}>
        {!data ? (
          <div>Loading...</div>
        ) : data.length > 0 ? (
          <div className={'policy-grid'}>
            <Grid
              data={data}
              id={gridId}
              grdTabelClass="table-striped table-hover table-sm"
              grdTableContainerClass="p-0"
              columns={columns}
              sortDefault={sortDefault}
              hiddenColumns={["selection", "combinedKey", ...(hiddenColumns || [])]} 
              paginationDisabled={true}
              showFilters={false}
              selectedColumn={selectedColumn}
              highlightColumn= {highlightColumn}
              disableSorting={disableSorting}
              enableDefaultSelection = {enableDefaultSelection}
              enableMandatorySelection = {enableMandatorySelection}

            />
          </div>
        ) : (
          <div className="no-record-message">{noRecordsMessage}</div>
        )}
      </ErrorBoundary>
    </>
  );
};

export default PolicyGrid;
